import React, { useState, useRef, useEffect } from 'react'
import { toast } from 'react-toastify'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { renderRadioField } from '../../../Forms/fieldRenderers'
import { FORM_PESO_BRUTO } from '../../../../config/forms'
import { Col } from 'react-bootstrap'
import { Button, Dialog, FormControlLabel, Switch } from '@material-ui/core'
import { COLORES } from '../../../../config/colores'
import CheckIcon from '@material-ui/icons/Check'
import DialogView from '../../../Dialogos/DialogView'
import RechazoBruto from '../rechazo/RechazoBruto'

function SeleccionCalleDeVolcado (props) {
  const { cpe, cereal, dataCalles, clearFormRechazo, cerealPorVolcadora } = props
  const [calleConfirmada, setCalleConfirmada] = useState(false)
  const [callesVolcadora, setCallesVolcadora] = useState([])
  const [selectedCalle, setSelectedCalle] = useState(null)
  const [showConfirmacion, setShowConfirmacion] = useState(false)
  const [todasLasCalles, setTodasLasCalles] = useState(false)
  const [calles, setCalles] = useState([])

  const fieldRef = useRef(null)

  useEffect(() => {
    const { change: formChange } = props
    if (fieldRef.current && fieldRef.current.focus) {
      fieldRef.current.focus()
    }

    if (cpe && cpe.calleDeVolcadora !== null && selectedCalle === null) {
      setCalleConfirmada(true)
      setSelectedCalle(cpe.calleDeVolcadora)
      formChange('calleVolcadora', cpe.calleDeVolcadora)
    } else if (cpe && cpe.calleDeVolcadora === null && selectedCalle === null) {
      formChange('calleVolcadora', null)
    }

    const volcadorasValidas = cerealPorVolcadora && cerealPorVolcadora.filter((v) => v.claveCereal === cereal)
    const calles = []
    const listadoCalles = []
    dataCalles && dataCalles.map((c) => {
      const calle = {
        fieldName: c.nombreCorto.trim(),
        name: c.nombre,
        label: c.nombre
      }
      listadoCalles.push(calle)

      // se renderizan aquellas calles que tengan el cereal que se esta pesando asignado a la volcadora
      const activa = volcadorasValidas.find((v) => v.claveVolcadora === c.volcadora && c.habilitado)
      if (activa) {
        const calle = {
          fieldName: c.nombreCorto.trim(),
          name: c.nombre,
          label: c.nombre
        }
        calles.push(calle)
      }
      return listadoCalles
    })

    setCallesVolcadora(calles)
    setCalles(listadoCalles)
  }, [cpe, cereal, dataCalles, selectedCalle, cerealPorVolcadora])

  const rechazarPesoBruto = () => {
    const { motivo, change: formChange } = props
    formChange('motivoRechazo', motivo)
    props.rechazarPesoBruto(motivo)
    handleClose()
  }

  const submitPesoBruto = () => {
    if (calleConfirmada) {
      // una vez guardado el peso bruto se permite modificar la calle
      props.actualizarCalleVolcadora()
    } else {
      props.submitPesoBruto()
      setCalleConfirmada(true)
    }
  }

  const onSelectCalleVolcadora = (value) => {
    setSelectedCalle(value)
  }

  const handleClose = () => {
    setShowConfirmacion(false)
    props.dialogOpen(false)
  }

  const handleOpenConfirmacion = () => {
    props.dialogOpen(true)
    setShowConfirmacion(true)
  }

  const disabled = (selectedCalle === null)

  const handleKeyDown = (e, index) => {
    const { change: formChange } = props
    // console.log(e.key)
    if (e.key === 'Enter' && selectedCalle) {
      submitPesoBruto()
    } else if (e.key === 'Enter' && !selectedCalle) {
      toast.error('Debe seleccionar una calle para guardar el peso.')
    } else if (e.key === 'x' || e.key === 'X') {
      handleOpenConfirmacion()
    } else {
      const value = `CALLE${e.key}`
      // console.log(callesVolcadora)
      const existe = !todasLasCalles ? callesVolcadora.filter((c) => c.fieldName === value) : calles.filter((c) => c.fieldName === value)
      // si es válido
      if (existe.length > 0) {
        formChange('calleVolcadora', value)
        onSelectCalleVolcadora(value)
      }
    }
  }

  const verTodasLasCalles = () => {
    const { change: formChange } = props
    if (todasLasCalles) {
      formChange('calleVolcadora', '')
      setSelectedCalle(null)
    }
    setTodasLasCalles(!todasLasCalles)
  }

  return (
    <>
      <Dialog
        open={showConfirmacion}
        onClose={handleClose}
        maxWidth='sm'
      >
        <DialogView
          confirmCallback={rechazarPesoBruto}
          cancelCallback={handleClose}
          title='Rechazar peso bruto'
          content={<RechazoBruto
            rechazarPesoBruto={rechazarPesoBruto}
            clearFormRechazo={clearFormRechazo}
            numero={cpe && cpe.numero ? cpe.numero : null}
          />
          }
        />
      </Dialog>

      <div className='container-calle-bruto'>
        <h5>Seleccionar calle de volcadora</h5>

        <div
          style={{ border: 'none', outline: 'none' }}
          tabIndex={0}
          onKeyDown={handleKeyDown}
          ref={fieldRef}
        >
          <Field
            onChange={onSelectCalleVolcadora}
            name='calleVolcadora'
            className='radio-field'
            options={todasLasCalles ? calles : callesVolcadora}
            component={renderRadioField}
          />
          <FormControlLabel
            key='todasLasCalles'
            control={<Switch
              color='primary'
              name='todasLasCalles'
              onClick={verTodasLasCalles}
              checked={todasLasCalles === true}
            />}
            label='Ver todas las calles'
          />
        </div>

        { !calleConfirmada
          ? <Button
            size='medium'
            style={{ margin: '2%', backgroundColor: COLORES.red.medium, color: '#ffffff' }}
            variant='contained'
            onClick={handleOpenConfirmacion}
          >
                            Rechazar
          </Button>
          : <></>
        }
        <Button
          size='medium'
          style={{
            margin: '2%',
            backgroundColor: !disabled ? COLORES.success : COLORES.grey.light,
            color: !disabled ? '#ffffff' : COLORES.grey.medium
          }}
          variant='contained'
          color='primary'
          onClick={() => submitPesoBruto()}
          disabled={disabled}
        >
                    Confirmar
        </Button>

        <Col md={12}>
          { calleConfirmada
            ? <div style={{ display: 'flex', justifyContent: 'center', padding: '8px auto', margintop: '8px' }}>
              <CheckIcon style={{ color: COLORES.success, margin: 0, padding: 0 }} />
              <h6 style={{ fontWeight: 'bold', margin: '3PX 8px', padding: 0 }} >Informando calle al chofer</h6>
            </div>
            : null
          }
        </Col>
      </div>

    </>
  )
}

const selector = formValueSelector(FORM_PESO_BRUTO)

const mapStateToProps = (state) => {
  return {
    dataCalles: state.volcadora.calleDeVolcadora,
    cerealPorVolcadora: state.volcadora.volcadorasConCereal,
    motivo: selector(state, 'motivoRechazo')
  }
}

const withRedux = connect(mapStateToProps, null)

const withReduxForm = reduxForm({
  form: FORM_PESO_BRUTO,
  destroyOnUnmount: false,
  // enableReinitialize: true,
  keepDirtyOnReinitialize: false
})

export default withRedux(withReduxForm(SeleccionCalleDeVolcado))
